import type { Category, Lang } from "../types";

interface PrefsProps {
  lang: Lang;
  strings: ReturnType<typeof import("../i18n").t>;
  categories: Category[];
  granted: Record<string, boolean>;
  onSave: (selections: Record<string, boolean>) => void;
  onClose: () => void;
}

export function renderPreferences(root: HTMLElement, props: PrefsProps): void {
  const { strings: s, lang } = props;
  const selections: Record<string, boolean> = {};

  const overlay = document.createElement("div");
  overlay.className = "dp-overlay";
  const modal = document.createElement("div");
  modal.className = "dp-modal";
  modal.innerHTML = `<div class="dp-mhead"><div class="t">${s.prefsTitle}</div><div class="d">${s.prefsIntro}</div></div><div class="dp-rows"></div><div class="dp-note">${s.receiptNote}</div><div class="dp-mfoot"><button class="dp-btn dp-reject" data-act="reject">${s.rejectAll}</button><button class="dp-btn dp-accept" data-act="save">${s.save}</button></div>`;
  const rows = modal.querySelector(".dp-rows")!;

  for (const cat of props.categories) {
    const on = cat.alwaysOn ? true : !!props.granted[cat.key];
    if (!cat.alwaysOn) selections[cat.key] = on;

    const row = document.createElement("div");
    row.className = "dp-row";

    const info = document.createElement("div");
    const name = document.createElement("div");
    name.className = "name";
    name.textContent = cat.name[lang === "en-US" ? "en" : "es"];
    const desc = document.createElement("div");
    desc.className = "desc";
    desc.textContent = cat.description[lang === "en-US" ? "en" : "es"];
    info.appendChild(name);
    info.appendChild(desc);
    if (cat.alwaysOn) {
      const pill = document.createElement("span");
      pill.className = "dp-pill";
      pill.textContent = s.alwaysOn;
      info.appendChild(pill);
    }

    const toggle = document.createElement("button");
    toggle.className = "dp-toggle";
    toggle.setAttribute("data-cat", cat.key);
    toggle.setAttribute("aria-checked", String(on));
    if (cat.alwaysOn) toggle.disabled = true;
    const knob = document.createElement("span");
    knob.className = "dp-knob";
    toggle.appendChild(knob);
    if (!cat.alwaysOn) {
      toggle.addEventListener("click", () => {
        const next = toggle.getAttribute("aria-checked") !== "true";
        toggle.setAttribute("aria-checked", String(next));
        selections[cat.key] = next;
      });
    }

    row.appendChild(info);
    row.appendChild(toggle);
    rows.appendChild(row);
  }

  modal.querySelector('[data-act="save"]')!.addEventListener("click", () => { props.onSave({ ...selections }); overlay.remove(); });
  modal.querySelector('[data-act="reject"]')!.addEventListener("click", () => {
    const rejected: Record<string, boolean> = {};
    for (const k of Object.keys(selections)) rejected[k] = false;
    props.onSave(rejected); overlay.remove();
  });
  overlay.addEventListener("click", (e) => { if (e.target === overlay) { props.onClose(); overlay.remove(); } });

  overlay.appendChild(modal);
  root.appendChild(overlay);
}
